<!-- HEADER -->
<header id="main-header" class="py-2 bg-success text-white">
    <div class="container">
      <div class="row">
        <div class="col-md-6">
          <h1>
            <i class="fas fa-users"></i> Students</h1>
        </div>
      </div>
    </div>
  </header>
  
  <!-- SEARCH -->
  <section id="search" class="py-4 mb-4 bg-light">
    <div class="container">
      <div class="row">
        <div class="col-md-6 ml-auto">
          <div class="input-group">
            <input type="text" class="form-control" placeholder="Search Students...">
            <div class="input-group-append">
              <button class="btn btn-success">Search</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  
  <!-- SESSIONS -->
  <section id="sessions">
    <div class="container">
      <div class="row">
        <div class="col">
          <div class="card">
            <div class="card-header text-center">
              <h4>All Students</h4>
            </div>
            <table class="table table-striped text-center">
              <thead class="thead-dark">
                <tr>
                  <!-- <th>#</th> -->
                  <th>Name</th>
                  <th>Student ID</th>
                  <th>Contact</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let student of studentList">
                  <!-- <td></td> -->
                  <td>{{ student.name }}</td>
                  <td>{{ student.code }}</td>
                  <td>{{ student.mobileNumber }}</td>
                  <td>
                    <a class="btn btn-success text-white" (click)="onDetails(student.code)" data-toggle="modal" data-target="#studentDetailsModal">
                      <i class="fas fa-angle-double-right"></i> Details
                    </a>
                  </td>
                </tr>
  
              </tbody>
            </table>
  
            <!-- PAGINATION -->
            <!-- <nav class="ml-4">
              <ul class="pagination">
                <li class="page-item disabled">
                  <a href="#" class="page-link">Previous</a>
                </li>
                <li class="page-item active">
                  <a href="#" class="page-link">1</a>
                </li>
                <li class="page-item">
                  <a href="#" class="page-link">2</a>
                </li>
                <li class="page-item">
                  <a href="#" class="page-link">3</a>
                </li>
                <li class="page-item">
                  <a href="#" class="page-link">Next</a>
                </li>
              </ul>
            </nav> -->
          </div>
        </div>
      </div>
    </div>
  </section>
  
  
  <!-- Student Details Modal -->
  <div class="modal fade" id="studentDetailsModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header bg-success text-white">
          <h5 class="modal-title" id="exampleModalLongTitle">{{ selectedStudent.name }}</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-5" style="text-align: right;">
              <b>StudentId :</b>
            </div>
            <div class="col-7">
              {{ selectedStudent.code }}
            </div>
          </div>
          <div class="row">
            <div class="col-5" style="text-align: right;">
              <b>Email :</b>
            </div>
            <div class="col-7">
              {{ selectedStudent.email }}
            </div>
          </div>
          <div class="row">
            <div class="col-5" style="text-align: right;">
              <b>Class :</b>
            </div>
            <div class="col-7">
              {{ selectedStudent.class }}
            </div>
          </div>
          <div class="row">
            <div class="col-5" style="text-align: right;">
              <b>School :</b>
            </div>
            <div class="col-7">
              {{ selectedStudent.school }}
            </div>
          </div>
          <div class="row">
            <div class="col-5" style="text-align: right;">
              <b>Contact :</b>
            </div>
            <div class="col-7">
              {{ selectedStudent.mobileNumber }}
            </div>
          </div>
          <div class="row">
            <div class="col-5" style="text-align: right;">
              <b>Location :</b>
            </div>
            <div class="col-7">
              {{ selectedStudent.location }}
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-outline-danger" data-dismiss="modal" (click)="onDeleteStudent(selectedStudent._id)">Remove {{ selectedStudent.name }}</button>
        </div>
      </div>
    </div>
  </div>
  